import { useState, React, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import AppBar from "@mui/material/AppBar";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import AccountCircle from "@mui/icons-material/AccountCircle";
import { getAPI, getAPIwithParams, postAPI } from "../../services/basehttpAPI";
import SnackbarComponent from "../../components/snackbar";
import Copyright from "../../components/copyright";

const theme = createTheme();
export default function Login() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const [authmodel, setauthmodel] = useState({
    username: null,
    password: null,
  });
  const [validusrname, setvalidusrname] = useState(null);
  const [validpwd, setvalidpwd] = useState(null);
  const [errorusernametext, seterrorusernametext] = useState(null);
  const [errorpasswordtext, seterrorpasswordtext] = useState(null);
  const [open, setOpen] = useState(false);
  const [message, setmessage] = useState(null);
  const [severity, setseverity] = useState(null);
  const [validRegex, setValidRegex] = useState(true);
  const [applicationLanguageId, setApplicationLanguageId] = useState(null);

  useEffect(() => {
      seterrorusernametext(validusrname ? "Por favor incluir Email.!" : null);
    if (!validusrname && !validRegex)
      //seterrorusernametext(!validRegex ? "Invalid Email.!" : null);
        seterrorusernametext(!validRegex ? "Email Invalido.!" : null);
    //seterrorpasswordtext(validpwd ? "Please Enter Password.!" : null);
      seterrorpasswordtext(validpwd ? "Indica una clave de acceso.!" : null);
  }, [validRegex, validusrname, validpwd]);

  const handleClose = () => {
    setOpen(false);
  };

  function handleChange(evt) {
    const value = evt.target.value;
    setauthmodel({
      ...authmodel,
      [evt.target.name]: value,
    });
  }

  function handleVaild(e) {
    if (e.target.value.trim() !== "") {
      if (e.target.name === "username") {
        const reg = new RegExp("^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$");
        let isValidregex = reg.test(e.target.value);
        setValidRegex(isValidregex);
        setvalidusrname(false);
      } else {
        setvalidpwd(false);
      }
    } else {
      if (e.target.name === "username") {
        setvalidusrname(true);
      }
      if (e.target.name === "password") {
        setvalidpwd(true);
      }
    }
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (
      authmodel.username != null &&
      authmodel.password != null &&
      validRegex
    ) {
      let url = "authentication/authenticate";
      const { data } = await postAPI(url, authmodel);
      if (data !== null) {
        if (data.isSuccess) {
          sessionStorage.setItem("authToken", data.responseData.token);
          sessionStorage.setItem("UserAppLangId", JSON.parse(window.atob(sessionStorage.getItem("authToken").split(".")[1])).ApplicationLanguageId);
          var userAppLangId = sessionStorage.getItem("UserAppLangId");
          console.log(userAppLangId);
          //setApplicationLanguageId(user.ApplicationLanguageId);
          //console.log(user.ApplicationLanguageId);
          //console.log(applicationLanguageId);
          const applicationLanguageModel = { applicationLanguageId: parseInt(userAppLangId) }
          let applicationLanguageURL = "translation/gettranslations"
          const applicationLanguageData = await getAPIwithParams(applicationLanguageURL, applicationLanguageModel);
          console.log(applicationLanguageData);

          sessionStorage.setItem("TranslationText", JSON.stringify(applicationLanguageData));
          const txt = JSON.parse(sessionStorage.getItem("TranslationText"));
          console.log(txt.action);

          navigate("/layout/shipments", {
            state: {
              Snackbaropen: true,
            },
          });

          // const decodeUserDetails = JSON.parse(window.atob(sessionStorage.getItem("authToken").split(".")[1]));
          console.log(JSON.parse(window.atob(sessionStorage.getItem("authToken").split(".")[1])));
        } else if (!data.isSuccess) {
          setseverity("error");
          setmessage(data.errorMessages);
          setOpen(true);
        } else {
            setseverity("error");
          //setmessage("Something went wrong.Please try again sometime.!");
            setmessage("Algo salió mal. ¡Por favor, inténtalo de nuevo ¡");
          setOpen(true);
        }
      } else {
        setseverity("error");
          //setmessage("Something went wrong.Please try again sometime.!");
          setmessage("Algo salió mal. ¡Por favor, inténtalo de nuevo ¡");
        setOpen(true);
      }
    } else {
      if (authmodel.username == null) {
        setvalidusrname(true);
      }
      if (authmodel.password == null) {
        setvalidpwd(true);
      }
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="lg" sx={{ mt: 0, mb: 0, ml: 0 }}>
        <CssBaseline />
        <Grid container spacing={3}>
          <Grid
            item
            xs={12}
            sm={4}
            md={4}
            lg={3}
            sx={{
              backgroundColor: "#D8DDE0CC",
              height: { sm: "100%", md: "100%", lg: "103vh" },
              display: { xs: "none", sm: "none", md: "block" },
            }}
          >
            <ImageList>
              <ImageListItem>
                <img
                  src={process.env.PUBLIC_URL + "/images/box.png"}
                  alt="box"
                  className="Loginlogo"
                />
                <img
                  src={process.env.PUBLIC_URL + "/images/deliveryvan.png"}
                  alt="van"
                  className="Loginlogo"
                />
                <img
                  src={process.env.PUBLIC_URL + "/images/globe.png"}
                  alt="globe"
                  className="Loginlogo"
                />
                <img
                  src={process.env.PUBLIC_URL + "/images/filelock.png"}
                  alt="filelock"
                  className="Loginlogo"
                />
              </ImageListItem>
            </ImageList>
          </Grid>
          <Grid item xs={0}></Grid>
          <Grid item xs={12} sm={7} md={6} lg={5}>
            <img
              src={process.env.PUBLIC_URL + "/images/albaraneslogo.png"}
              alt="logo"
              height="120"
            />
            <Box
              sx={{
                marginTop: "15%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography component="h1" variant="h5">
              Hola ! Bienvenido al Portal de Albaranes de Indas
                              {/* Hello! Welcome to Indas Shipment Tracking Portal */}
              </Typography>
              <Box
                component="form"
                onSubmit={handleSubmit}
                noValidate
                sx={{ mt: 1 }}
              >
                <TextField
                  margin="normal"
                  fullWidth
                  id="username"
                  label="Correo Electronico"//"Email Address"
                  name="username"
                  required={true}
                  autoComplete="off"
                  onChange={handleChange}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Icon>
                          <AccountCircle />
                        </Icon>
                      </InputAdornment>
                    ),
                  }}
                  onBlur={handleVaild}
                  error={errorusernametext !== null ? true : false}
                  helperText={errorusernametext}
                />
                <TextField
                  margin="normal"
                  fullWidth
                  name="password"
                  label="Contraseña"//"Password"
                  type={showPassword ? "text" : "password"}
                  id="password"
                  required={true}
                  autoComplete="off"
                  onChange={handleChange}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          edge="end"
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  onBlur={handleVaild}
                  error={errorpasswordtext !== null ? true : false}
                  helperText={errorpasswordtext}
                />
                <Grid container>
                  <Grid item xs></Grid>
                  <Grid item style={{ marginTop: 5 }}>
                    <Link
                      href={process.env.PUBLIC_URL + "/forgotpassword"}
                      variant="body2"
                      underline="hover"
                    >
                      ¿Olividaste la contraseña?
                      {/* Forgot password ? */}
                    </Link>
                  </Grid>
                </Grid>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="success"
                  sx={{ mt: 3, mb: 2 }}
                >
                  {" "}
                  Acceso
                  {/* LOGIN */}
                </Button>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <AppBar
        position="fixed"
        sx={{
          top: "auto",
          bottom: 0,
          backgroundColor: "white",
          zIndex: "0",
          boxShadow: "0",
          width: { xs: "100%", sm: "90%", md: "62%", lg: "75%", xl: "80%" },
        }}
      >
        <Copyright align="left" />
      </AppBar>
      <SnackbarComponent
        open={open}
        handleClose={handleClose}
        message={message}
        severity={severity}
      />
    </ThemeProvider>
  );
}
